// extracted by mini-css-extract-plugin
export default {"message":"Mensagem_message__Qq5ko","entrada-aviso":"Mensagem_entrada-aviso__xBzY6","entrada-aviso-mobile":"Mensagem_entrada-aviso-mobile__DJmA2"};